import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Grid } from '@material-ui/core';
import { useStyles } from "./styles";

function CustomerFeedbackComponent() {
  const classes = useStyles();
  var settings = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: 300,
    autoPlay: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <Grid container item xs={10} className={classes.feedbackSectionWrapper}>
        <Grid item xs={6} className={classes.feedbackSectionImage}></Grid>
        <Grid item xs={6} className={classes.feedbackCarousel}>
            <Slider {...settings} className={classes.sliderComponent}>
                <div>
                    <h3>We love using the MommyVue service! It was so great to have access to my Ultrasound pictures after
                        every visit and to be abkle to share them with my friends and family
                    </h3>
                    <span>Camara Family</span>
                </div>
                <div>
                    <h3>When my OB doctor told me I could see my US pictures online, I was surprised! During my previous pregnancies,
                    I was always given printouts that either got lost or ruined. This service helped keep these memories safe for posterity!
                    </h3>
                    <span>Campos Family</span>
                </div>
                <div>
                    <h3>I never liked the printouts my OB gave.  They were always folded or wrinkled.  Plus, how can you save them for 
                    your kids when they’re older? Now I just download and store them with our family photos for future memories.
                    </h3>
                    <span>Frank Family</span>
                </div>
            </Slider>
        </Grid>
    </Grid>
  )
}

export default CustomerFeedbackComponent
